export const CREATE_SALES_ORDER = 'CREATE_SALES_ORDER';
export const GET_SALES_ORDERS = 'GET_SALES_ORDERS';
export const SALES_ORDER_REQUEST = 'SALES_ORDER_REQUEST';
export const UPDATE_SALES_ORDER = 'UPDATE_SALES_ORDER';
export const DELETE_SALES_ORDER = 'DELETE_SALES_ORDER';
export const SALES_ORDER_REQUEST_FAILURE = 'SALES_ORDER_REQUEST_FAILURE';
export const SALES_ORDER_REQUEST_SUCCESS = 'SALES_ORDER_REQUEST_SUCCESS';
export const GET_SALES_ORDERS_PAGE = 'GET_SALES_ORDERS_PAGE';
